import { styled, css } from "styled-components";

export const HeroFooterImageContainer = styled.div<{ $altStyling?: boolean }>`
  width: 100%;
  background: linear-gradient(
    to bottom,
    ${({ theme, $altStyling }) =>
  $altStyling
    ? css`
            ${theme.colors.primary[950]} 30%
          `
    : css`
            ${({ theme }) => theme.colors.base} 30%
          `},
    ${({ theme, $altStyling }) =>
  $altStyling
    ? css`
            ${({ theme }) => theme.colors.base} 0%
          `
    : css`
            ${theme.colors.default[50]} 0%
          `}
  );
  padding-bottom: ${({ $altStyling }) => ($altStyling ? "0" : "96px")};
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  overflow: hidden;
`;

export const FooterImageContainer = styled.div`
  display: flex;
  justify-content: center;

  & img {
    z-index: 5;
  }
`;
